import script from "./VerifyAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyAccountView.vue?vue&type=script&setup=true&lang=js"

import "./VerifyAccountView.vue?vue&type=style&index=0&id=1aaff581&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aaff581"]])

export default __exports__